import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { rem } from 'polished';
import { mixins, spaces, spacingCurves } from '../../core/styles/theme/default';
import { getSpaceOrCurve } from '../../core/utils/Utils';
import { SpaceInterface, SpaceStyleInterface } from '../../types';

export const StyledSpacer = styled.div(
  ({ staticSpace, spacingCurve }: SpaceStyleInterface) => css`
    ${staticSpace &&
    css`
      padding-top: ${rem(spaces[staticSpace])};
    `}

    ${spacingCurve &&
    css`
      ${mixins.responsiveStyles(
        spacingCurves.component[spacingCurve]('padding-top'),
      )}
    `}
  `,
);

const Spacer = ({ space }: SpacerProps) => {
  const spaceType = getSpaceOrCurve(space);

  return Object.keys(spaceType).length === 1 ? (
    <StyledSpacer {...spaceType} className={'spacer'} />
  ) : null;
};

export type SpacerProps = {
  space: SpaceInterface;
};

export default Spacer;
